import { GObject } from '../GObject';
export class Text extends GObject {
    constructor(props) {
        super(props);
        this.text = props.text;
        this.font = props.font;
        this.color = props.color;
        this.positioning = props.positioning || 'top left';
    }
    render(ctx) {
        const textSize = ctx.measureText(this.text);
        const [vertical, horizontal] = this.positioning.split(' ');
        if (horizontal === 'center') {
            ctx.textAlign = 'center';
        }
        ctx.font = this.font;
        ctx.fillStyle = this.color;
        ctx.fillText(this.text, this.position.x, this.position.y);
    }
}
//# sourceMappingURL=Text.js.map